import {
  Control,
  Controller,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { useRef, useState } from 'react';
import GroupsAutocomplete from '../../../../shared/groups-autocomplete';
interface RemoveFromGroupActionProps {
  description?: string;
  setValue: UseFormSetValue<RulesEngineFormValues>;
  control: Control<RulesEngineFormValues>;
  watch: UseFormWatch<RulesEngineFormValues>;
  errors: FieldErrors<RulesEngineFormValues>;
}

import { RulesEngineFormValues } from '../rules-engine-form-page';
import ActionDescription from './action-description';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Delete from '@mui/icons-material/Delete';

export default function RemoveFromGroupAction({
  setValue,
  watch,
  errors,
  control,
  description,
}: RemoveFromGroupActionProps) {
  const removeGroupInfo = watch('removeGroupInfo');
  const [autoCompleteResponse, setAutoCompleteResponse] = useState('');
  const autocompleteKey = useRef(new Date().getTime().toString());
  const [alreadySelectedError, setAlreadySelectedError] = useState(false);

  function removeSelection(email: string) {
    const newList = removeGroupInfo.groupEmail!.filter(
      (groupEmail) => groupEmail !== email
    );
    setValue(`removeGroupInfo.groupEmail`, newList);
  }

  return (
    <Stack sx={{ p: 1 }}>
      <ActionDescription description={description} />
      <Stack gap={1}>
        <Stack flexDirection={'row'} gap={2}>
          <Box sx={{ width: 400 }}>
            <Controller
              rules={{
                required: 'Group is required.',
              }}
              name="removeGroupInfo.groupEmail"
              control={control}
              render={() => (
                <GroupsAutocomplete
                  newKey={`${autocompleteKey.current}`}
                  autocompleteValue={autoCompleteResponse}
                  setAutoCompleteValue={setAutoCompleteResponse}
                  errors={
                    !!errors.removeGroupInfo?.groupEmail || alreadySelectedError
                  }
                  helperText={
                    alreadySelectedError
                      ? 'Group is already selected.'
                      : errors.removeGroupInfo?.groupEmail
                      ? errors?.removeGroupInfo?.groupEmail?.message
                      : ' '
                  }
                  onSelection={(value) => {
                    if (!value) return;
                    if (removeGroupInfo.groupEmail?.includes(value)) {
                      setAlreadySelectedError(true);
                    } else {
                      setAlreadySelectedError(false);
                      setValue(
                        `removeGroupInfo.groupEmail`,
                        removeGroupInfo.groupEmail
                          ? [...removeGroupInfo.groupEmail, value]
                          : [value]
                      );
                      autocompleteKey.current = new Date().getTime().toString();
                      setAutoCompleteResponse('');
                    }
                  }}
                />
              )}
            />
          </Box>
        </Stack>
      </Stack>
      <Box sx={{ height: '100%' }}>
        <Paper sx={{ minWidth: 470, overflow: 'hidden', maxHeight: 190 }}>
          <TableContainer sx={{ minWidth: 470, maxHeight: 190 }}>
            <Table size={'small'} stickyHeader aria-label="searched-groups">
              <TableHead>
                <TableRow>
                  <TableCell>Selected Groups</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {removeGroupInfo.groupEmail
                  ? removeGroupInfo.groupEmail.map((group) => (
                      <TableRow key={group}>
                        <TableCell>
                          <Stack
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Typography variant="body2">{group}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Tooltip arrow title="Delete">
                            <span>
                              <IconButton
                                onClick={() => {
                                  removeSelection(group);
                                }}
                              >
                                <Delete />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </Stack>
  );
}
